module.exports = __webpack_public_path__ + "img/flag-spain.70744882.png";